import { Component, OnInit, ViewChild } from '@angular/core';

import * as _ from 'lodash-es';
import { StateService } from '@uirouter/angular';
import { AdminService } from '../../../services/core.admin.service';
import { ConstantsService } from '../../../services/core.constants.service';
import { StateStackService } from '../../../services/core.state-stack.service';
import { UiService } from '../../../services/core.ui.service';
import { UserRest } from '../../../services/core.user.rest.service';
import { GfTitleService } from '../../../services/core.title.service';
import { UserService } from '../../../services/core.user.service';
import { NgForm } from '@angular/forms';

@Component({
    selector: 'admin-user-add-view',
    template: require('./admin.user-add.component.html')
})
export class AdminUserAddComponent implements OnInit {

    @ViewChild('f', { static: false }) userAddForm!: NgForm;

    protected options: any = {};

    private userTemplate = {
        status: 1,
        useCustomAvatar: 'N',
        isSiteAdmin: false
    };
    public user: any = _.cloneDeep(this.userTemplate);

    protected avatarPreview = '/core/img/default-avatar.png';
    protected errors = {};
    private form: any = {};

    private statuses = {
        '-1': 'Pending approval',
        '0': 'Pending',
        '1': 'Active',
        '2': 'Deleted',
        '3': 'Suspended'
    };

    constructor(
        private adminService: AdminService, 
        private constantsService: ConstantsService,
        private stateStackService: StateStackService,
        private $window: Window,
        private userRest: UserRest,
        private uiService: UiService,
        private userService: UserService,
        private titleService: GfTitleService,
        public stateService: StateService
    ) {
        this.options = {
            language: this.constantsService.languages,
            country: this.constantsService.countries,
            timezone: this.constantsService.timezones
        }; 
    }
    
    ngOnInit() {
        this.titleService.setTitle('Site Admin', 'Add User');
    };

    save(andNew?: any) {

        // The changes we make before submitting
        // are for API requirements only, they do not
        // change the state of the user.

        // For this reason, we change and submit a copy,
        // and leave the this.user set as the user left it.
        var user: any = _.cloneDeep(this.user);

        // Massage the cloned data before submitting, for UI/API differences.
        user.language = user?.language?.id ?? null;
        user.timezone = user?.timezone?.label ?? null;
        user.ccode = user?.ccode?.id ?? null;

        for (var x in user) {
            if (user[x] === null) {
                delete user[x];
            }
        }
        delete user.lastLogin;
        delete user.createDate;

        this.adminService.newUser(user)
        .then((r) => {
            this.uiService.message.showSuccess('Changes saved', 'Success');

            if (user.isSiteAdmin) {
                this.userRest.setAdmin(user.unixName);
            }

            if (user.useCustomAvatar == 'Y' && this.user.customAvatar) {
                this.userService.profile.uploadAvatar(
                    user.unixName,
                    this.user.customAvatar
                ).then((result) =>{
                    this.uiService.message.showSuccess("Avatar uploaded successfully");
                }, (result) => {
                    this.uiService.message.showError("Avatar failed to upload");
                });
            }

            if (andNew) {
                this.user = _.cloneDeep(this.userTemplate);
                this.onChangeCustomAvatar('N');
                this.userAddForm.reset();
            }
            else {
                this.goToList();
            }
        }, (r) => {
            this.errors = r.error;
            this.uiService.message.showError("Sorry, could not create this user.  Check the validation messages and try again.");
        });

    };

    clearError (name) {
        if (this.errors[name]) {
            delete this.errors[name];
        }
    };

    setStatus (value) {
        this.userRest.update(this.user.unixName, { unixName: this.user.unixName, status: value })
        .then(function (r) {
            this.user.status = value;
            this.uiService.message.showSuccess(this.user.unixName + ' is now ' + this.statuses[value], 'Success');
        });
    };

    valid () {
        return this.user.unixName && this.user.email && this.user.firstname && this.user.lastname &&
            this.user.password && this.user.confirm == this.user.password && _.isEmpty(this.errors);
    };

    onChangeCustomAvatar (newValue) {
        this.user.useCustomAvatar = newValue;
        if (this.user.useCustomAvatar == 'N') {
            var isGroup = this.user.isGroup == 'Y';
            if (!isGroup) {
                this.avatarPreview = '/core/img/default-avatar.png';
            } else {
                this.avatarPreview = '/core/img/default-avatar-group.png';
            }
        } else {
            this.avatarPreview = '/api/user/none/avatar';
        }
    };

    getPreview(file: File) {
        var fr = new FileReader();
        fr.addEventListener('load', () => { 
            this.avatarPreview = fr.result as any; 
        });
        fr.readAsDataURL(file);
    };

    fileSelected = ($event) => {
        this.addFile($event?.target?.files);
    };

    //when user selects a file store it locally, it will be uploaded
    // after submit creates a new valid tracker item
    addFile = ($files) => {
        var f = _.first($files);
        if (! f) {
            return;
        }

        this.getPreview(f as any);
        this.user.useCustomAvatar = 'Y';
        this.user.customAvatar = f;
    };

    switchAdmin () {
        this.user.isSiteAdmin = !this.user.isSiteAdmin;
    };

    goToList () {
        this.stateStackService.back('home.admin.users', {});
    };
}
